<template>
    <footer>
        <span class="copright">{{ $t('footer.copright') }} <br><span class="separador">-</span>  {{ $t('footer.direitos') }}</span>
        <a :href="link" class="made-by"><i> {{ $t('footer.feitoPor') }} </i> <span> {{ $t('footer.nome') }} </span></a>
    </footer>
</template>

<script>
export default {
    name: 'Footer',
    data: () => ({
        link: 'https://api.whatsapp.com/send?phone=5547996168262&text=Ol%C3%A1%20Felipe!%20=)'
    })

}
</script>

<style lang="sass" scoped>
    @import '../assets/sass/_mixin'

    footer
        background-color: black
        width: 100%
        display: flex
        flex-direction: column
        align-items: center
        padding: 20px 15px

        .logo
            width: 80px
            margin-bottom: 10px
        .copright
            color: white
            br
                display: none
            @include device(mobile)
                &
                    text-align: center
                    br
                        display: block
                    .separador
                        display: none
        .made-by
            color: white
            text-decoration: none

            &:hover
                span
                    color: green
</style>
